import { mapState } from 'vuex';
import isArray from 'lodash/isArray';
import { readableFileSizeFromBytes } from '@/utils/vuex';
import { localizeDate } from '@/utils/date';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
const techSpecKeys = ['Model', 'Usage', 'Configuration', 'Connectivity', 'Frequency', 'TX Power', 'TX Distance', 'Power Supply', 'Operating Temperature', 'Security', 'Mounting', 'Dimensions', 'Weight', 'Standard', 'Battery', 'Battery Life', 'Firmware', 'Precision', 'Installation Height', 'Other'];
export default {
  name: 'NiotaClassicDevicetypesDetails',
  components: {
    MarkdownItVueLight
  },
  props: {
    deviceTypeId: {
      type: String,
      required: true
    },
    deviceTypeData: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      techSpecKeys: techSpecKeys,
      formDialog: false,
      editedItem: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    deviceName() {
      return get(this.deviceTypeData, 'properties.manufacturer.device_name');
    }
  },
  watch: {
    deviceTypeData() {
      if (!this.deviceTypeData) {
        return;
      }
      if (!this.deviceTypeData.properties) {
        this.deviceTypeData.properties = {};
      }
      if (!this.deviceTypeData.properties.manufacturer) {
        this.deviceTypeData.properties.manufacturer = {};
      }
      if (!isArray(this.deviceTypeData.properties.manufacturer.device_manual_file)) {
        if (this.deviceTypeData.properties.manufacturer.device_manual_file && this.deviceTypeData.properties.manufacturer.device_manual_file.constructor === Object) {
          this.deviceTypeData.properties.manufacturer.device_manual_file = [this.deviceTypeData.properties.manufacturer.device_manual_file];
        }
      }
      if (!this.deviceTypeData.properties.technical_specs) {
        this.deviceTypeData.properties.technical_specs = {};
      }
    }
  },
  methods: {
    clickManufacturerFile(file) {
      window.open(this.getManualFileUrl(file.storagePath));
    },
    readableFileSizeFromBytes(fileSize) {
      return readableFileSizeFromBytes(fileSize);
    },
    localizeDate(date) {
      return localizeDate(date);
    },
    getManualFileUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }
      return `${location.origin}${image}`;
    }
  }
};